import type { FaireProductEntity } from "../../entity_types/product";

export const p_93hyhdtyg4: FaireProductEntity = {
  token: "p_93hyhdtyg4",
  type: "product",
  name: "Wholesale Jewelry Set Wholesale",
  brandToken: "b_jbt25unvjp",
  brandName: "Gooddiy",
  imageUrl:
    "https://cdn.faire.com/fastly/b8b6ab78fee64c0d89fce6ab57c4c1c54f5840a4d12efc5491effa5d59053593.jpeg",
  galleryImageUrls: [],
  priceDollars: 3.33,
  description:
    "Venta al por mayor, venta al por mayor, estilo vintage casual, nudo de lazo, chapado en acero de titanio, incrustaciones, tallado, conjunto de joyas de piedras preciosas artificiales, Color: Oro, Estilo: Casual, Estilo vintage, Diseño: Enchapado, Incrustación, Tallado, Género: Mujer, Patrón: Nudo de lazo, Material: Acero de titanio, Ocasión: Diario, Cantidad: 1 pieza, Clasificación: Conjunto de joyas, Material de incrustación: Piedras preciosas artificiales, Peso: 15 g",
  tags: [],
  msrpDollars: 6.65,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:54:29.035Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
